import React, { useContext, useEffect, useState, useRef } from 'react';
import { useParams } from 'react-router-dom';
import { Link } from 'react-router-dom';
//import studentData from '../data/studentData.json'
//import moduleData from '../data/moduleData.json'

import InputField from '../components/InputField';
import SelectField from '../components/SelectField';
import TextAreaField from '../components/TextAreaField';
import UploadField from '../components/UploadField';
import Modal from '../components/Modal';

import arrowReturnLeft from '../assets/arrow-return-left.svg';

import { HttpClient } from '../../services/http-client';
import { AppContext } from '../../App';
import { useForm, Controller, useFieldArray } from 'react-hook-form';

import { PDFExport, savePDF } from '@progress/kendo-react-pdf';

import logo from '../assets/insol-logo.svg';
import saripa from '../assets/saripa.png';

const Sidebar = ({ studentId, activeSection, setActiveSection }) => {
    const { courseId } = useParams();

    return (
      <div className="sidebar w-208 bg-ui h-full py-4 text-lg">
        <ul>
            <li className="py-2 px-4"><Link to={`../course/edit/${courseId}/students`}><img src={arrowReturnLeft} height={20} className="" alt="status icon" /></Link></li>
            <li className={`py-2 px-4 ${activeSection === 'notes' ? 'bg-uiactive' : ''}`}><Link to={`../course/${courseId}/students/${studentId}/notes`} onClick={() => setActiveSection('notes')}>Notes</Link></li>
            <li className={`py-2 px-4 ${activeSection === 'assessments' ? 'bg-uiactive' : ''}`}><Link to={`../course/${courseId}/students/${studentId}/assessments`} onClick={() => setActiveSection('assessments')}>Assessments</Link></li>
            <li className={`py-2 px-4 ${activeSection === 'result' ? 'bg-uiactive' : ''}`}><Link to={`../course/${courseId}/students/${studentId}/result`} onClick={() => setActiveSection('result')}>Result</Link></li>
        </ul>
      </div>
    );
};

const Notes = ({ register, handleSubmit, handleNotesSubmit }) => {

    return (
        <div className='text-sm p-6 w-full'>
            <h2 className='text-uidarker font-bold pr-6 text-lg relative flex mb-6'>
                Notes
                <span className="absolute bottom-0 left-0 w-full h-0.5 bg-ui"></span>
            </h2>
            <form onSubmit={handleSubmit(handleNotesSubmit)}>
                <TextAreaField 
                    label="Student notes"
                    name="notes"
                    register={register}
                />
                <span className="flex w-full h-0.5 bg-ui mt-6 mb-6"></span>
                <button type="submit" className="bg-kenticoblue hover:bg-blue-700 text-white font-medium py-2 px-6 rounded-full">
                    Save Notes
                </button>
            </form>
        </div>
    )
};

const getAssessments = (studentAssessments, course) => {

    const allAssessments = [];
    course.moduleGroups.forEach(mg => mg.modules.forEach(m => m.assessments.forEach(a => allAssessments.push(a))));
    const copy = [];
    for (const assessment of allAssessments) {
        const completedAssessment = studentAssessments.find(sa => sa.courseModuleAssessmentId == assessment.courseModuleAssessmentId) || {}
        copy.push({
            ...assessment,
            ...completedAssessment
        })
    }
    return copy;
}

const Assessments = ({ course, handleAssessmentsSubmit, assessments }) => {
    const moduleGroups = course.moduleGroups;

    const { register, handleSubmit, reset, control, setValue, watch, formState: { errors } } = useForm({
        defaultValues: {
            assessments
        }
    });

    const {
        fields: assessmentFields
    } = useFieldArray({
        control,
        name: 'assessments'
    });

    const hasModuleGroups = moduleGroups && moduleGroups.length;
    const hasAssessments = assessmentFields && assessmentFields.length > 0;

    let currentModuleId = null;
    let currentModuleGroupId = null;

    return (
        <div className='text-sm p-6 w-full'>
            <form onSubmit={handleSubmit(handleAssessmentsSubmit)}>
                {hasModuleGroups && hasAssessments && (
                <>
                    {assessmentFields.map((assessment, index) => {
                        let module, moduleGroup;                                   
                        moduleGroups.forEach(mg => {
                            const modTmp = mg.modules.find(m => m.courseModuleId == assessment.courseModuleId);
                            if (modTmp) {
                                module = modTmp;
                                moduleGroup = mg;
                            }
                        });
                        
                        const isNextModule = currentModuleId != assessment.courseModuleId;
                        const isNextModuleGroup = currentModuleGroupId != moduleGroup.courseModuleGroupId;
                        currentModuleId = assessment.courseModuleId;
                        currentModuleGroupId = moduleGroup.courseModuleGroupId;

                        return (<div key={index}>
                            {isNextModuleGroup &&                                        
                            <h2 className='text-uidarker font-bold pr-6 text-lg relative flex mb-6'>
                                {moduleGroup.groupName}
                                <span className="absolute bottom-0 left-0 w-full h-0.5 bg-ui"></span>
                            </h2>}
                            {isNextModule && 
                            <h2 className='text-uidarker font-bold pr-6 text-md relative flex mb-6'>
                                {module.moduleName}
                                <span className="absolute bottom-0 left-0 w-full h-0.5 bg-ui"></span>
                            </h2>}
                            <div>
                                <h2 className='text-uidarker font-bold pr-6 text-md relative flex mb-6'>
                                    {assessment.assessmentTitle} - {assessment.assessmentType}
                                </h2>
                                <UploadField 
                                    label="Assessment Paper"
                                    name={`assessments[${index}].assessmentPaper`}
                                    register={register}
                                    setValue={setValue}
                                    defaultFile={{
                                        ...watch(`assessments[${index}]`),
                                        type: "PAPER"
                                    }}
                                />
                                <InputField 
                                    label="Assessment Paper Score"
                                    name={`assessments[${index}].assessmentScore`}
                                    register={register}
                                />
                                <UploadField 
                                    label="Marked Paper"
                                    name={`assessments[${index}].markedPaper`}
                                    register={register}
                                    setValue={setValue}
                                    defaultFile={{
                                        ...watch(`assessments[${index}]`),
                                        type: "MARKED_PAPER"
                                    }}
                                />
                                <UploadField 
                                    label="Resubmitted Assessment Paper"
                                    name={`assessments[${index}].resubmittedAssessmentPaper`}
                                    register={register}
                                    setValue={setValue}
                                    defaultFile={{
                                        ...watch(`assessments[${index}]`),
                                        type: "RESUBMITTED_PAPER"
                                    }}
                                />
                                <InputField 
                                    label="Resubmitted Assessment Paper Score"
                                    name={`assessments[${index}].resubmittedScore`}
                                    register={register}
                                />
                                <UploadField 
                                    label="ResubmittedMarked Paper"
                                    name={`assessments[${index}].resubmittedMarkedPaper`}
                                    register={register}
                                    setValue={setValue}
                                    defaultFile={{
                                        ...watch(`assessments[${index}]`),
                                        type: "RESUBMITTED_MARKED_PAPER"
                                    }}
                                />
                            </div>
                            {<span className="flex w-full h-0.5 bg-ui mt-6 mb-6"></span>}
                        </div>)
                    })}
                    <button type="submit" className="bg-kenticoblue hover:bg-blue-700 text-white font-medium py-2 px-6 rounded-full">
                        Save Assessments
                    </button>
                </>
                )}
                {!hasAssessments && (<div>No assessments are setup on the course modules.</div>)}
            </form>
        </div>
    )
}

const Result = ({ register, handleSubmit, handleResultSubmit }) => {
    const pdfExportComponent = useRef(null);
    const [emailMessage, setEmailMessage] = useState();


    const handleStatusChange = (e) => {
        const selectedStatus = e.target.value;
        let newMessage = '';

        switch (selectedStatus) {
            // accepted
            case '2':
                newMessage = "";
                break;
            // rejected
            case '3':
                newMessage = "";
                break;
            // banned
            case '4':
                newMessage = "";
                break;
            // enrolled
            case '5':
                newMessage = "";
                break;
            default:
                newMessage = ""
        }
        setEmailMessage(newMessage);
    };

    const exportPDFWithComponent = () => {
        if (pdfExportComponent.current) {
            pdfExportComponent.current.save();
        }
    };
    return (
        <div className='text-sm p-6 w-full'>
            <h2 className='text-uidarker font-bold pr-6 text-lg relative flex mb-6'>
                Result
                <span className="absolute bottom-0 left-0 w-full h-0.5 bg-ui"></span>
            </h2>
            <form onSubmit={handleSubmit(handleResultSubmit)}>
                <SelectField
                    label="Course Result"
                    name="result"
                    options={[
                        { text: "Please select", value: null },
                        { text: "Pass", value: "PASS" },
                        { text: "Fail", value: "FAIL" }
                    ]}
                    valueField="value"
                    textField="text"
                    register={register}
                />
                <SelectField
                    label="Course Overall Mark"
                    name="mark"
                    options={[
                        { text: "None", value: null },
                        { text: "Pass", value: "PASS" },
                        { text: "Merit", value: "MERIT" },
                        { text: "Distinction", value: "DISTINCTION" }
                    ]}
                    valueField="value"
                    textField="text"
                    register={register}
                />
                <TextAreaField 
                    label="Email message"
                    name="reason"
                    register={register}
                />
                <button type="submit" className="bg-kenticoblue hover:bg-blue-700 text-white font-medium py-2 px-6 rounded-full">
                    Save Result
                </button>
            </form>
        </div>
    )
};

const EditForm = () => {
    const { courseId, studentId, courseStudentId, section } = useParams();
    const [course, setCourse] = useState(null);
    const [studentNotes, setStudentNotes] = useState(null);
    const [studentAssessments, setStudentAssessments] = useState(null);
    const [activeSection, setActiveSection] = useState('notes');
    const [showSuccessModal, setShowSuccessModal] = useState(false);
    const { action } = useParams();
    const [isCourseRequested, setIsCourseRequested] = useState(false);
    const [formData, setFormData] = useState({});
    const { register, handleSubmit, reset, control, setValue, formState: { errors } } = useForm();
    const appContext = useContext(AppContext);

    console.log(studentId)

    useEffect(() => {
        const numericStudentId = Number(studentId);
        console.log(numericStudentId)
            appContext.httpClient.post({
                path: "coursestudent",
                body: {
                    courseStudentId: numericStudentId
                },
                authRedirectPath: appContext.loginPath
            }).then(response => {
                console.log(response)
                if (response.success && response.result) {
                    setStudentNotes(response.result.notes)
                    setStudentAssessments(response.result.assessments)
                    console.log(response.result.assessments)
                    reset(response.result);
                }
            }).catch(error => {
                console.error("Error fetching student assessments:", error);
            });
    }, [courseStudentId]);

    useEffect(() => {
        if (courseId && !isCourseRequested) {
            console.log("fetching course data");
            setIsCourseRequested(true);
            appContext.httpClient.get({
                path: "course/" + courseId,
                authRedirectPath: appContext.loginPath
            }).then(response => {
                if (response.result) {
                    const courseData = response.result;
                    console.log(courseData);
                    setCourse(courseData);
                    //reset(courseData)
                } else {
                    console.log("Applicant not found");
                }
            }).catch(error => {
                console.error("Error fetching applicant data:", error);
            });
        }
    }, [courseId]);


    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
    };

    const handleNotesSubmit = async (data) => {

        appContext.httpClient.post({
            path: "coursestudent/note",
            body: {
              courseStudentId: studentId,
              notes: data.notes
            }
        });

        setShowSuccessModal(true);
    };

    const handleAssessmentsSubmit = async (data, b) => {

        for (const ass of data.assessments) {
            if (ass.assessmentScore === "") ass.assessmentScore = null;
            if (ass.resubmittedScore === "") ass.resubmittedScore = null;
        }

        const response = await appContext.httpClient.post({
            path: "assessment",
            body: {
                courseStudentId: studentId,
                assessments: data.assessments
            }
        });

        if (response.success && response.result) {
            setShowSuccessModal(true);
        }
    };

    const handleResultSubmit = async (data) => {

        appContext.httpClient.post({
            path: "coursestudent/result",
            body: {
                courseStudentId: studentId,
                result: data.result,
                mark: data.mark,
                reason: data.reason
            }
        });

        setShowSuccessModal(true);
    };

    const handleCloseSuccessModal = () => {
        setShowSuccessModal(false);
    };

    const handleContinueEditing = () => {
        window.location.reload();
    }

    /*
    if (!applicant) {
        console.log("Applicant data:", applicant);
        return <div>Loading...</div>;
    }
    */

    // Render the edit form with the applicant data
    return (
        <div className="flex h-full">
            <Sidebar studentId={studentId} setActiveSection={setActiveSection} activeSection={activeSection} />
            <div className="flex-1 overflow-y-auto">
                <h2 className='text-uidarker px-6 pt-6 text-md relative flex items-center'>
                    {course ? course.courseTitle : "Loading..."}
                    <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" fill="currentColor" className="bi bi-chevron-right" viewBox="0 0 16 16">
                        <path fillRule="evenodd" d="M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708"/>
                    </svg>
                    Students
                    <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" fill="currentColor" className="bi bi-chevron-right" viewBox="0 0 16 16">
                        <path fillRule="evenodd" d="M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708"/>
                    </svg>
                    {formData.studentFirstName} {formData.studentLastName}
                </h2>
                {activeSection === 'notes' && (
                    <Notes
                        formData={formData}
                        register={register}
                        errors={errors}
                        handleSubmit={handleSubmit}
                        handleNotesSubmit={handleNotesSubmit}
                    />
                )}
                {(activeSection === 'assessments' && course && studentAssessments) && (
                    <Assessments
                        formData={formData}
                        assessments={getAssessments(studentAssessments, course)}
                        course={course}
                        register={register}
                        control={control}
                        errors={errors}
                        setValue={setValue}
                        handleAssessmentsSubmit={handleAssessmentsSubmit}
                        handleInputChange={handleInputChange}
                    />
                )}
                {activeSection === 'result' && (
                    <Result
                        formData={formData}
                        register={register}
                        control={control}
                        errors={errors}
                        handleSubmit={handleSubmit}
                        handleResultSubmit={handleResultSubmit}
                    />
                )}
                <Modal
                    isOpen={showSuccessModal}
                    onClose={handleCloseSuccessModal}
                    className="max-w-xl"
                >
                    <div className="p-6">
                        <h2 className="text-lg font-bold mb-4">Success</h2>
                        <p>The student has been successfully saved.</p>
                        <div className="flex justify-end mt-4">
                            <Link to="/education-admin/courses">
                                <button
                                    className="bg-ui font-medium py-2 px-6 mr-3 rounded-full"
                                >
                                    Back to courses
                                </button>
                            </Link>
                            <button
                                onClick={handleContinueEditing}
                                className="bg-kenticoblue hover:bg-blue-700 text-white font-medium py-2 px-6 rounded-full"
                            >
                                Continue editing
                            </button>
                        </div>
                    </div>
                </Modal>
            </div>
        </div>
    );
};

export default EditForm;